import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import BackIcon from '@material-ui/icons/ArrowBack'
import LinearProgress from '@material-ui/core/LinearProgress'
import Typography from '@material-ui/core/Typography'

import { styles } from './styles'
import Title from '../../components/Title'
import { withContext } from '../../context'
import { beforeUpload, isMobile } from '../../utils'
import { Avatar, Col, Form, Input, message, Row, Upload } from 'antd'
import { ButtonUploadDiv } from '../SignupBin/AddBin'
import AddIcon from '../../assets/icons/Add_image.png'
import BinSelect from '../SignupBin/BinSelect'
import { ButtonEx } from '../HeroLocations/index.style'
import Card from '@material-ui/core/Card'
import axios from 'axios'
import { useDeepEffect } from '../../utils/hooks'
import { CardContentEx, FormItem } from '../../shared.style'
import { RESPONSE_MESSAGE } from '../../utils/constants'
import imageCompression from 'browser-image-compression'

export const AccountProfileBin = ({
  history: { goBack, push },
  context: { state },
  me
}) => {
  const [form] = Form.useForm()
  const [imageUrl, setImageUrl] = useState('')
  const [avatarId, setAvatarId] = useState(0)
  const [binSelect, setBinSelect] = useState('1')
  const [heroData, setHeroData] = useState({})

  async function fetchData() {
    const res = await axios.get(
      process.env.REACT_APP_API_ENDPOINT + `/hero/detail/${me.id}`
    )
    setHeroData(res.data)
  }

  useDeepEffect(() => {
    fetchData()
  }, [])

  useDeepEffect(() => {
    setImageUrl(heroData.image)

    form.setFieldsValue({
      email: heroData.email,
      name: heroData.name,
      tel: heroData.tel
    })

    if (heroData.private) {
      setBinSelect('2')
    } else {
      setBinSelect('1')
    }
  }, [heroData])

  const handleProfileChange = async (info) => {
    const formData = new FormData()
    try {
      const options = {
        maxSizeMB: 0.8,
        // maxWidthOrHeight: 256,
        useWebWorker: true
      }
      const compressedFile = await imageCompression(info.file, options)
      formData.append('image', compressedFile)
      const res = await axios.post(
        process.env.REACT_APP_API_ENDPOINT + `/bin/avatar/image`,
        formData,
        {
          headers: {
            'content-type': 'multipart/form-data'
          }
        }
      )
      const { data } = res
      setAvatarId(data.id)
      setImageUrl(data.url)
    } catch (err) {
      console.log(err)
    }
  }

  const handleChangeBin = (value) => {
    setBinSelect(value)
  }

  const onFinish = async (values) => {
    const formData = {
      avatarId: avatarId === 0 ? null : avatarId,
      id: me.id,
      email: values.email,
      name: values.name,
      private: binSelect !== '1',
      tel: values.tel
    }

    try {
      await axios.put(
        process.env.REACT_APP_API_ENDPOINT + `/bin/updateHeroBin`,
        formData
      )

      message.success({
        content: RESPONSE_MESSAGE.SUCCESS
      })
      await push('/')
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <React.Fragment>
      <AppBar position="sticky">
        <Toolbar style={styles.toolbar}>
          <IconButton
            id="btnBack"
            color="inherit"
            aria-label="Menu"
            style={styles.menuButton}
            onClick={() => goBack()}>
            <BackIcon />
          </IconButton>
          <Typography
            id="titlePage"
            variant="h6"
            color="inherit"
            style={styles.grow}>
            โปรไฟล์
          </Typography>
          <IconButton style={{ width: '48px' }} />
        </Toolbar>
        {state.uploading ? (
          <LinearProgress />
        ) : (
          <div style={{ height: '4px' }} />
        )}
      </AppBar>
      <Title name="โปรไฟล์" />
      <Card elevation={isMobile ? 0 : 1} square>
        <CardContentEx>
          <Form form={form} onFinish={onFinish} layout="vertical">
            <FormItem label="รูปภาพโปรไฟล์ (เช่น รูปบุคคล, โลโก้)">
              <Upload
                name="profileImg"
                listType="picture"
                showUploadList={false}
                beforeUpload={beforeUpload}
                onChange={handleProfileChange}>
                <Row justify="center">
                  {imageUrl ? (
                    <Avatar src={imageUrl} size={128} />
                  ) : (
                    <ButtonUploadDiv>
                      <img src={AddIcon} alt="" width={128} height={128} />
                    </ButtonUploadDiv>
                  )}
                </Row>
              </Upload>
            </FormItem>
            <Form.Item
              name="tel"
              label="เบอร์โทรศัพท์ (Telephone)"
              rules={[
                {
                  required: true,
                  message: 'กรอกเบอร์โทรศัพท์'
                }
              ]}>
              <Input />
            </Form.Item>
            <Form.Item
              name="email"
              label="อีเมล (Email)"
              rules={[
                {
                  type: 'email',
                  message: 'The input is not valid E-mail!'
                },
                {
                  required: true,
                  message: 'กรอกอีเมล'
                }
              ]}>
              <Input />
            </Form.Item>
            <Form.Item
              name="name"
              label="ชื่อ Circular Bin"
              rules={[
                {
                  required: true,
                  message: 'กรอกชื่อ Circular Bin'
                }
              ]}>
              <Input placeholder="เช่น ชื่อบุคคล, องค์กร, แบรนด์" />
            </Form.Item>
            <Form.Item label="ประเภทถังขยะ">
              <Row gutter={[8, 8]}>
                <Col span={12}>
                  <BinSelect
                    name="สาธารณะ"
                    onChange={handleChangeBin}
                    value={binSelect}
                    valueSelect="1"
                  />
                </Col>
                <Col span={12}>
                  <BinSelect
                    name="ส่วนตัว"
                    onChange={handleChangeBin}
                    value={binSelect}
                    valueSelect="2"
                  />
                </Col>
              </Row>
            </Form.Item>
            <Row justify="center" style={{ marginTop: 15 }}>
              <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
                บันทึก
              </ButtonEx>
            </Row>
          </Form>
        </CardContentEx>
      </Card>
    </React.Fragment>
  )
}

AccountProfileBin.propTypes = {
  history: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired
}

export default compose(withRouter, withContext)(AccountProfileBin)



// WEBPACK FOOTER //
// ./src/pages/AccountProfileBin/index.js